export default "__VITE_ASSET__C6ej230w__"